import ActiveOrders from "../components/retail/ActiveOrders";
import CategoryCatalogue from "../components/retail/CategoryCatalogue";
import CategoryCircular from "../components/retail/CategoryCircular";
import MidBanner from "../components/retail/MidBanner";
import NewArrivals from "../components/retail/NewArrival";
import RetailBanner from "../components/retail/RetailBanner";
import SectionGrid from "../components/retail/SectionGrid";
import { HomePageSkeleton } from "../components/retail/RetailSkeletons";
import { useMenuAggregate } from "../hooks/useMenuAggregate";

/**
 * Default home page composition. Theme page slots may rearrange or restyle
 * this freely, but must keep rendering every data-driven section (§7).
 */
export default function Home() {
  const { isLoading } = useMenuAggregate();

  if (isLoading) {
    return <HomePageSkeleton />;
  }

  return (
    <div className="min-h-screen w-full bg-white font-sans text-gray-900 pb-24">
      <RetailBanner />

      <ActiveOrders />

      <div className="space-y-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <CategoryCircular />
        </div>

        <NewArrivals />

        <SectionGrid startIndex={0} maxSections={2} />

        <CategoryCatalogue />

        <SectionGrid startIndex={2} />

        <MidBanner />
      </div>
    </div>
  );
}
